import React, { ReactNode } from 'react'
import styled from '~/app/components/styled'
import { Typography } from '@yanolja-org/ya-com-core'

/**
 * OrderTitle component
 * author: soojin.oh
 * $description$
 */

// type definitions
type OrderTitleProps = {
  title: string
  subTitle: string
  rightAppended?: ReactNode
  className?: string
}

// styled components
const TitleContainer = styled.div`
  display: inline-block;
`
const Title = styled.div`
  ${Typography('body1').bold};
  margin-bottom: 0.2rem;
  color: ${({ theme }) => theme.color.gray900};
`
const SubTitle = styled.div`
  ${Typography('body2').regular};
  color: ${({ theme }) => theme.color.gray600};
`
const RightAppended = styled.div`
  display: inline-block;
`
const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: ${({ theme }) => theme.color.white};
`

// OrderTitle component
const OrderTitle: React.FunctionComponent<OrderTitleProps> = function ({
  title,
  subTitle,
  rightAppended,
  className,
}) {
  return (
    <Container className={className}>
      <TitleContainer>
        <Title className={'title'} data-testid={'orderList-title'}>
          {title}
        </Title>
        <SubTitle data-testid={'orderList-subtitle'}>{subTitle}</SubTitle>
      </TitleContainer>
      <RightAppended>{rightAppended}</RightAppended>
    </Container>
  )
}

export default OrderTitle
